<div class="container">
  <mat-form-field [ngClass]="isFilter ? 'isFilter' : null" appearance="outline">
    <input type="text" matInput [formControl]="control" [matAutocomplete]="auto" [placeholder]="isFilter ? 'Filtre' : null">
    <mat-label>{{label}}</mat-label>

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="isFilter ? selectedOptionForFilter.emit() : null">
        <mat-option *ngFor="let item of filteredList | async" [value]="item" [disabled]="disabled">
            {{ item.display }}
        </mat-option>
    </mat-autocomplete>
    <mat-error>{{ errorMsg}}</mat-error>
  </mat-form-field>
  <fa-icon *ngIf="hasTooltip" class="infoCircle" appChangeColorTheme attribute="color" [icon]="getFaIcon('faInfoCircle')" [matTooltip]="tooltipText"></fa-icon>
</div>



